import React from 'react';
import PropTypes from 'prop-types';
import Snap from 'snapsvg-cjs';
import settings from '../settings.json';

const thalamusRegions = settings.regionList;

const regions = [
  // Rostral Thalamus
  {
    coords: ['m 77.95548,270.71657 c -1.25296,-2.90459 -3.75887,-5.12572 -4.95487,-8.08725 -1.70857,-4.21448 0.0569,-5.23963 2.90458,-8.65678 3.92971,-4.78401 10.25143,-10.93488 11.10573,-17.3705 1.13905,-8.37202 -4.72706,-16.23146 1.82248,-23.74918 6.60648,-7.63162 10.25144,-2.96153 14.52288,3.30324 5.52438,8.0303 12.52953,15.0924 19.81945,21.52803 3.07544,2.73372 8.08725,4.67011 5.63829,8.59983 -1.25294,2.05029 -5.58133,4.10057 -7.68858,5.63829 -6.15087,4.32839 -13.44078,7.57468 -20.33203,10.42231 -6.72039,2.84761 -15.54801,8.37201 -22.83793,8.37201 z'],
    color: '#cd4a45',
    label: { x: 91, y: 244, text: 'VM' },
    name: 'VM',
    clickable: true,
  },
  {
    coords: ['m 150.34206,220.31364 c -5.29657,11.33353 -6.72039,9.22629 -11.84611,14.35201 -8.59983,8.71373 -13.09907,3.07544 -22.09757,-6.72039 -9.3402,-10.13753 -15.0924,-17.76917 -14.97849,-31.32385 0.0569,-9.73887 -0.56952,-33.60196 4.78401,-41.91701 3.24628,-5.01182 5.6383,-2.10724 10.87792,-6.9482 4.784,-4.4423 39.98064,58.20541 33.26024,72.55744 z'],
    color: '#cd4a45',
    label: { x: 113, y: 198, text: 'VA' },
    name: 'VA',
    clickable: true,
  },
  {
    coords: ['m 153.47445,218.14944 c 8.37201,-13.72554 -31.49472,-68.05819 -28.64709,-72.55744 3.53105,-5.52439 8.37202,-12.75735 11.96002,-17.94003 6.83429,-10.02362 11.96001,-10.82096 21.30023,-1.93637 9.28324,8.77068 25.51469,21.1863 28.02061,33.6589 3.36019,16.91488 -35.76616,63.84371 -32.63377,58.77494 z'],
    color: '#6390b9',
    label: { x: 148, y: 166, text: 'VL' },
    name: 'VL',
    clickable: true,
  },

  {
    coords: ['m 43.61316,285.58115 c -4.95487,0.74039 -21.35719,3.18934 -25.68558,1.02515 -5.63828,-2.73372 -2.56284,-10.25144 -2.56284,-16.00364 0,-11.27658 -6.66344,-46.13149 8.99848,-46.81493 24.83126,-1.13904 21.58498,23.06575 33.48803,33.08939 5.01183,4.27144 18.16784,6.26477 15.49108,14.80763 -1.93638,6.09392 -23.46442,13.8964 -29.72917,13.8964 z'],
    color: '#a4772b',
    label: { x: 26, y: 263, text: 'RE' },
    name: 'RE',
    clickable: true,
  },
  {
    coords: ['m 217.20426,133.46113 c -1.87944,-2.56286 -4.4423,-4.5562 -7.40383,-5.80916 -7.11905,-2.96152 -13.66858,-5.58133 -18.28173,-11.50438 -7.00516,-9.05546 -13.32688,-32.57682 -16.23145,-28.36234 -8.77068,12.87126 -20.55984,25.79947 -7.85944,39.80978 10.6501,11.8461 23.2366,21.75583 22.78098,39.12634 -0.9682,34.57015 -27.39413,54.33265 -51.82674,74.20905 11.33353,15.9467 53.07969,-25.17298 61.22389,-35.42442 8.99849,-11.33355 16.51621,-22.72404 19.81946,-36.67739 1.42382,-6.03696 6.15088,-16.28841 5.29659,-22.49623 -0.51258,-3.75886 -4.44231,-8.71372 -7.51773,-12.87125 z'],
    color: '#ffffff',
    label: { x: 195, y: 153, text: 'RT' },
    name: 'RT',
    clickable: false,
  },
  {
    coords: ['m 138.78071,112.33176 c 0,0 -4.10057,-23.57832 -31.43777,-20.21812 l 4.38535,-31.153 c 0,-3.75885 6.72039,-6.66344 10.47925,-6.66344 0,0 24.54652,0 41.34749,19.4208 5.35354,6.15087 6.15087,15.03544 2.10724,22.09755 l -8.42896,14.69374 c -3.92972,8.54287 -18.4526,1.82247 -18.4526,1.82247 z'],
    color: '#6390b9',
    label: { x: 132, y: 84, text: 'LD' },
    name: 'LD',
    clickable: true,
  },
  {
    coords: ['m 133.99671,117.40053 c 0,12.3587 -17.48442,36.39263 -33.14634,28.9888 -10.59316,-5.06876 -14.23812,-27.05241 -6.83431,-35.02576 5.46744,-5.8661 13.32688,-21.86974 24.88823,-16.4023 11.10573,5.23962 15.09242,9.28325 15.09242,22.43926 z'],
    color: '#6390b9',
    label: { x: 102, y: 124, text: 'AV' },
    name: 'AV',
    clickable: true,
  },
  {
    coords: ['m 93.44654,204.19609 c -4.784,5.01181 -7.17601,9.45411 -13.44077,9.68192 -5.23962,0.17085 -22.83794,-6.9482 -26.19814,-11.10573 -0.96819,-1.196 -4.95486,-13.66859 -4.27143,-16.23146 1.93639,-7.57468 18.96517,-16.2884 24.14784,-22.66708 2.05029,-2.5059 9.79582,-17.99697 12.47258,-18.50954 6.26478,-1.30991 11.3905,10.76401 12.13088,15.03544 0.68343,4.49925 -1.53772,43.79645 -4.84096,43.79645 z'],
    color: '#cd4a45',
    label: { x: 66, y: 188, text: 'AM' },
    name: 'AM',
    clickable: true,
  },
  {
    coords: ['m 54.54801,228.17308 -30.98213,-9.51107 c -4.38534,-1.36685 -7.46075,-3.81581 -6.15085,-8.20115 l 0.56951,-2.2781 c 1.36686,-4.38534 6.09391,-6.89124 10.47926,-5.52439 l 30.98213,9.51107 c 4.38534,1.36685 6.89124,6.0939 5.52439,10.47925 v 0 c -1.25296,4.38533 -5.98001,6.89124 -10.42231,5.52439 z'],
    color: '#ffffff',
    label: { x: 35, y: 221, text: 'Rh' },
    name: 'Rh',
    clickable: false,
  },
  {
    coords: ['m 66.109375,230.79297 c -6.696324,0 -12.130859,5.43453 -12.130859,12.13086 0,6.69632 5.434535,12.13086 12.130859,12.13086 6.696324,0 12.130859,-5.43454 12.130859,-12.13086 0,-6.69633 -5.434535,-12.13086 -12.130859,-12.13086 z m 0,0.57031 c 6.38853,0 11.560547,5.17202 11.560547,11.56055 0,6.38853 -5.172017,11.56054 -11.560547,11.56055 -6.38853,0 -11.560547,-5.17202 -11.560547,-11.56055 0,-6.38853 5.172017,-11.56055 11.560547,-11.56055 z'],
    color: '#ffffff',
    label: {
      x: 57,
      y: 246,
      text: 'SMT',
      fontSize: 8,
    },
    name: 'SMT',
    clickable: false,
  },
  {
    coords: ['m 76.58861,136.47961 c -8.77068,7.63163 -17.31354,17.02879 -26.99546,23.52136 -17.99697,12.01697 -17.71221,-17.59831 -16.68706,-27.45108 1.13905,-10.93488 2.22115,-22.83794 4.89791,-33.48805 0.85429,-3.30324 2.22114,-5.29657 5.35353,-7.11905 3.92971,-2.27811 5.06876,-1.76554 8.42896,0.51257 2.73371,1.82248 5.92306,4.95487 8.99848,6.09391 3.81582,1.42381 8.59983,0.62648 12.87127,1.93638 7.176,2.22115 14.52286,5.6383 13.15601,13.72555 -0.91124,6.09391 -2.67676,20.33202 -10.02364,22.26841 z'],
    color: '#cd4a45',
    label: { x: 47, y: 127, text: 'MD' },
    name: 'MD',
    clickable: true,
  },
  {
    coords: ['m 23.67978,147.7562 c -8.31504,-0.45563 -5.92305,-14.8646 -5.92305,-20.95851 0,-10.36534 -0.2278,-20.73069 0,-31.09604 0.11387,-4.15753 0.74039,-7.97334 5.12572,-8.94154 3.47411,-0.74038 11.5044,2.61981 12.75736,6.32173 0.62648,1.76552 -1.08209,6.72039 -1.36687,8.54287 -0.91124,5.69524 -1.82248,11.33353 -2.79066,17.02878 -0.79734,5.06876 -2.61982,29.10271 -7.8025,29.10271 z'],
    color: '#eab44b',
    label: {
      x: -122,
      y: 32,
      text: 'PVT',
      fontSize: 12,
      transform: 'rotate(-88.889525)',
    },
    name: 'PVT',
    clickable: true,
  },
  {
    coords: ['m 98.11665,95.13212 c -3.3602,4.15753 -5.23963,8.03029 -11.27659,5.7522 -5.35353,-1.99333 -9.16934,-7.40381 -8.82763,-13.09907 0.39866,-6.26477 3.07543,-11.21964 2.39201,-17.76917 -0.51258,-4.61315 -2.05029,-10.02363 2.67676,-13.04211 4.04362,-2.61981 10.5362,-1.93638 15.14936,-2.10724 4.72705,-0.22781 8.2581,-0.62648 9.39714,4.72706 1.36687,6.60648 -1.5377,15.0924 -3.01848,21.58498 -1.13904,4.84096 -3.18933,10.19448 -6.49257,13.95335 z'],
    color: '#7f7f7f',
    label: { x: 82, y: 81, text: 'AD' },
    name: 'AD',
    clickable: true,
  },
  {
    coords: ['m 79.55014,147.47144 c -3.81581,5.06876 -7.28991,10.59316 -11.78915,15.03545 -3.01848,2.96152 -6.20782,6.49257 -9.62496,8.94153 -2.22115,1.59467 -3.70192,2.61982 -6.15087,0.56952 -3.58801,-3.01848 -1.02515,-6.15086 1.30991,-8.54286 5.69524,-5.69526 11.44744,-11.33355 17.08573,-17.02879 1.99333,-1.99333 5.7522,-7.51772 8.42896,-7.40383 3.64496,0.11387 2.50592,6.09392 0.74038,8.42898 z'],
    color: '#cd4a45',
    label: {
      x: -79,
      y: 156,
      text: 'IAD',
      fontSize: 8,
      transform: 'rotate(-48.697646)',
    },
    name: 'IAD',
    clickable: true,
  },
  {
    coords: ['m 37.51924,183.97796 c -4.4423,1.0821 -11.3905,4.38534 -15.88974,3.87277 -2.96153,-0.28476 -4.32837,-3.98667 -3.30325,-6.9482 1.19601,-3.47411 6.89125,-5.01181 10.08059,-5.98001 5.06877,-1.48076 12.18784,-7.68858 17.2566,-4.15752 1.87943,1.3099 3.92971,5.41048 3.24628,7.85944 -1.08209,3.64494 -8.14419,5.06876 -11.39048,5.35352 z'],
    color: '#eab44b',
    label: {
      x: -28,
      y: 185,
      fontSize: 11,
      transform: 'rotate(-16.499479)',
      text: 'CM',
    },
    name: 'CM',
    clickable: true,
  },
  {
    coords: ['m 22.42684,191.89436 c 6.83429,-1.99334 26.25507,-11.73222 24.54649,2.33505 -1.59465,13.61164 -27.96364,7.23296 -24.54649,-2.33505 z'],
    color: '#ffffff',
    label: {
      x: 28,
      y: 198,
      fontSize: 8,
      text: 'IAM',
    },
    name: 'IAM',
    clickable: false,
  },
  {
    coords: ['m 25.1036,173.32785 c -1.70858,0.45563 -5.69524,2.392 -7.17602,0.56953 -1.02512,-1.25296 0.11387,-5.18268 0.11387,-6.94821 0.11387,-5.52439 -1.93636,-15.37716 4.89792,-16.97183 6.37868,-1.53772 8.48592,3.30324 10.5362,8.54287 2.73372,7.17601 1.13905,14.80764 -8.37201,14.80764 z'],
    color: '#eab44b',
    label: {
      x: 19,
      y: 166,
      text: 'IMD',
      fontSize: 8,
    },
    name: 'IMD',
    clickable: true,
  },
  // Middle Thalamus
  {
    coords: ['m 418.07963,222.30326 c -55.36253,14.02039 -1.91732,-48.11269 9.04734,-65.30864 9.287,-14.61954 29.05933,-53.3853 48.9515,-52.36673 26.60279,1.31816 32.11507,62.85208 25.58421,81.72568 -11.74357,33.97247 -43.61898,31.51589 -73.81671,34.81129 z'],
    color: '#6390b9',
    label: { x: 448, y: 178, text: 'VB' },
    name: 'VB',
    clickable: true,
  },
  {
    coords: ['m 401.54277,246.32966 c -6.11144,0.35948 -57.8191,-0.3595 -57.8191,-2.15698 9.6465,-8.98743 21.44998,-8.1486 34.21213,-8.74776 11.20433,-0.53924 20.31158,-3.17556 31.21633,-6.2313 4.31396,-1.1983 33.97246,-11.26422 28.1606,5.81188 -2.75614,8.26844 -29.05936,11.32416 -35.76996,11.32416 z'],
    color: '#ffffff',
    label: {
      x: 402,
      y: 240,
      text: 'VPLpc',
      fontSize: 8,
    },
    name: 'VPLpc',
    clickable: false,
  },
  {
    coords: ['m 345.88064,234.10676 c -12.40264,3.05572 -24.98504,8.02876 -36.78853,5.69202 -8.1486,-1.61772 -12.70223,-4.31396 -12.34272,-14.37986 0.23966,-6.83046 5.09288,-11.02459 12.28281,-12.10308 11.62373,-1.73756 25.10488,3.89454 37.08812,3.7148 7.36969,-0.11974 15.99761,-2.69622 23.24748,-1.55782 4.13421,0.65908 17.73518,6.53087 17.73518,11.92332 -12.16298,6.83044 -27.38169,6.71062 -41.22234,6.71062 z'],
    color: '#cd4a45',
    label: { x: 317, y: 229, text: 'VPMpc' },
    name: 'VPMpc',
    clickable: true,
  },
  {
    coords: ['m 374.52058,271.73411 c -11.98324,4.13422 -28.58001,14.91912 -40.86282,7.3697 -8.02879,-4.91314 -8.02879,-14.26005 -13.48115,-21.15041 -3.3553,-4.25406 -12.88198,-9.40684 -6.05153,-13.24148 4.43379,-2.45656 20.79091,2.33673 25.88379,2.93589 7.78909,0.89875 15.87778,1.19832 23.60697,2.63631 4.49372,0.83884 29.47876,5.1528 30.85682,8.56802 1.19834,2.9359 -17.67526,12.10305 -19.95208,12.88197 z'],
    color: '#cd4a45',
    label: { x: 339, y: 270, text: 'VM' },
    name: 'VM',
    clickable: true,
  },
  {
    coords: ['m 322.69307,269.63702 a 18.454182,16.896362 0 0 1 -18.45418,16.89637 18.454182,16.896362 0 0 1 -18.45418,-16.89637 18.454182,16.896362 0 0 1 18.45418,-16.89636 18.454182,16.896362 0 0 1 18.45418,16.89636 z'],
    color: '#ffffff',
    label: {
      x: 291,
      y: 273,
      text: 'SPFm',
      fontSize: 10,
    },
    name: 'SPFm',
    clickable: false,
  },
  {
    coords: ['m 277.1568,272.75269 c 0.47932,-4.55364 1.37807,-9.40684 0.89873,-14.02039 -0.41941,-3.7148 -2.33673,-12.52248 1.13842,-15.27862 3.47513,-2.69623 22.88798,-2.2169 25.34453,-1.01858 8.92752,4.4338 -6.65069,9.16718 -11.02457,10.90475 -5.2127,2.09707 -5.93171,1.61773 -7.90894,5.87179 -2.15698,4.61354 -0.0599,14.20013 -8.44817,13.54105 z'],
    color: '#a4772b',
    label: {
      x: 281,
      y: 252,
      text: 'RE',
      fontSize: 10,
    },
    name: 'RE',
    clickable: true,
  },
  {
    coords: ['m 472.84301,96.35945 c -34.45179,25.8838 -55.06296,66.32723 -76.99227,102.51659 -6.05153,10.00601 -20.31158,21.92933 -32.47457,10.24568 -7.07011,-6.77054 6.53087,-26.9623 10.90475,-35.76998 10.06592,-20.19173 13.18156,-34.99104 11.92332,-57.45961 -1.0785,-19.11326 3.29538,-18.21452 19.77233,-26.24328 7.13002,-3.47513 14.37988,-10.96466 22.34874,-11.38408 3.95445,-0.17974 9.94607,2.87599 13.66087,4.07431 2.81605,0.89873 32.89397,9.46675 30.85683,14.02037 z'],
    color: '#cd4a45',
    label: { x: 401, y: 129, text: 'PO' },
    name: 'PO',
    clickable: true,
  },
  {
    coords: ['m 539.1103,178.14505 c 0.95865,6.35111 0.89873,23.78672 -3.95447,28.40027 -5.03297,4.73337 -19.23311,3.23548 -25.52429,3.17556 -11.74358,-0.0599 -11.08451,-1.67766 -6.2912,-12.5824 6.77052,-15.45838 7.90892,-28.75978 4.13421,-45.29664 -2.03716,-8.80768 -9.287,-22.5884 -6.53085,-31.57581 3.47513,-11.444 13.84062,0.47932 17.73517,5.57218 11.02457,14.43981 17.61536,34.33197 20.43143,52.30684 z'],
    color: '#ffffff',
    label: { x: 514, y: 175, text: 'RT' },
    name: 'RT',
    clickable: false,
  },
  {
    coords: ['m 508.31338,113.13599 c 8.1486,4.01438 11.20432,14.7993 17.0162,5.21272 3.7747,-6.29122 5.15278,-22.169 2.69621,-28.99943 -4.13421,-11.68367 -14.55961,-0.59917 -21.27023,5.09287 -8.5081,7.13002 -12.04316,15.09888 1.55782,18.69384 z'],
    color: '#ffffff',
    label: {
      x: 505,
      y: 107,
      text: 'LGv',
      fontSize: 11,
    },
    name: 'LGv',
    clickable: false,
  },
  {
    coords: ['m 490.51827,98.75611 c -11.08449,-6.89036 -24.20614,-10.90474 -27.86102,-23.84663 -1.8574,-6.53088 -3.3553,-14.20013 -1.61774,-20.97067 2.51648,-9.76633 6.23128,-6.59078 15.75795,-4.61354 11.74358,2.39665 39.54468,8.08868 42.60041,23.60696 1.25824,6.05154 -21.09049,25.82388 -28.8796,25.82388 z'],
    color: '#6390b9',
    label: { x: 473, y: 75, text: 'LGd' },
    name: 'LGd',
    clickable: true,
  },
  {
    coords: ['m 446.89931,77.60569 c -12.94188,-3.23546 -23.66688,-1.43798 -35.82986,3.95448 -7.72919,3.47514 -16.59679,11.50391 -23.48715,5.99162 -4.67345,-3.77472 -5.81186,-11.20434 -8.74774,-16.17738 -1.85742,-3.17556 -8.20854,-7.78909 -8.86762,-11.38406 -1.31814,-7.24987 8.68786,-6.77054 15.0989,-7.48954 18.9335,-2.09705 39.24508,-3.47513 60.81488,-5.39245 8.8676,-0.77891 10.78491,-0.0599 11.74357,11.62373 0.29958,4.07431 0.59917,11.26426 -0.59916,14.91915 -2.39663,7.4296 -2.03714,3.95445 -10.12582,3.95445 z'],
    color: '#cd4a45',
    label: { x: 411, y: 68, text: 'LP' },
    name: 'LP',
    clickable: true,
  },
  {
    coords: ['m 336.0544,185.81432 c -8.02877,8.02877 -18.93351,26.24328 -31.15641,14.67946 -6.47095,-6.11145 -7.0102,-17.37569 -7.60936,-25.64413 -0.59916,-8.38827 -2.93588,-20.13183 -0.65908,-28.1606 3.05573,-10.66508 12.04314,-13.06172 21.15042,-10.78492 8.02876,2.03716 11.02458,6.41104 15.03896,-1.97723 1.37807,-2.87597 -1.73757,-4.97303 4.97304,-9.46675 10.725,-7.18994 14.67945,-24.02639 16.83644,-26.96227 3.65488,-5.03297 17.13603,34.69145 9.52667,48.77176 -2.5764,4.79329 -6.2912,8.8676 -9.6465,12.70224 -7.24986,8.2085 -13.00181,17.13601 -18.45418,26.84244 z'],
    color: '#cd4a45',
    label: { x: 312, y: 165, text: 'MD' },
    name: 'MD',
    clickable: true,
  },
  {
    coords: ['m 347.73805,209.7808 c -5.03296,2.81605 -27.8011,6.17134 -21.03058,-4.61356 3.11565,-4.97304 11.50392,-6.53086 15.03896,-12.40264 4.49371,-7.48952 4.85322,-17.79511 10.90475,-24.62556 8.74776,-9.82626 13.96047,4.73338 12.58239,12.163 -1.25823,7.01017 -8.44817,29.47876 -17.49552,29.47876 z'],
    color: '#eab44b',
    label: {
      x: 71,
      y: 395,
      text: 'PCN',
      fontSize: 10,
      transform: 'rotate(-49.225325)',
    },
    name: 'PCN',
    clickable: true,
  },
  {
    coords: ['m 289.85903,239.37937 c -5.27263,0.77892 -8.98743,2.45657 -11.44399,-1.37807 -1.67765,-2.69621 0.23967,-13.12164 0.23967,-16.83644 -0.0599,-8.5081 -2.03716,-10.006 4.79328,-11.32416 1.55782,-0.29957 15.75796,2.75615 15.63813,3.41523 -0.719,4.55363 -7.48952,7.0102 -8.26844,11.50389 -0.41941,2.51648 5.93171,14.61955 -0.95865,14.61955 z'],
    color: '#eab44b',
    label: {
      x: 280,
      y: 220,
      text: 'CM',
      fontSize: 8,
    },
    name: 'CM',
    clickable: true,
  },
  {
    coords: ['m 375.05982,161.00902 c -4.79329,7.48952 -12.88197,0.53923 -11.8634,-6.05153 0.71899,-4.79329 5.09288,-9.04735 5.99163,-14.08032 1.37807,-7.36968 1.31815,-16.29718 -0.35951,-23.42722 -1.91732,-8.20851 -5.51229,-14.91912 -9.6465,-22.16898 -4.91314,-8.56802 -13.90055,-19.11326 -16.41703,-28.69985 -1.85741,-7.13001 3.65488,-11.38407 10.36549,-7.07011 2.87598,1.85742 5.81187,7.48952 7.72919,10.00602 6.89036,9.10725 13.00183,16.7166 16.83644,27.56144 6.65071,19.05333 10.54525,47.0941 -2.63631,63.93055 z'],
    color: '#eab44b',
    label: {
      x: -208,
      y: 344,
      text: 'CL',
      transform: 'rotate(-102.96198)',
    },
    name: 'CL',
    clickable: true,
  },
  {
    coords: ['m 297.46837,137.22229 c -12.64232,3.23547 -18.1546,3.23547 -18.1546,-12.04314 0,-9.28702 -3.83462,-28.58003 1.97724,-36.36912 10.78491,-14.4398 15.75795,9.94608 19.59259,17.55544 2.09707,4.13421 5.63212,9.40684 6.35112,13.96046 0.77891,5.03296 -2.81605,15.63813 -9.76635,16.89636 z'],
    color: '#eab44b',
    label: {
      x: 283,
      y: 119,
      text: 'PVT',
      fontSize: 10,
    },
    name: 'PVT',
    clickable: true,
  },
  {
    coords: ['m 292.19576,207.86348 h -8.50811 c -3.17556,0 -5.81186,-2.5165 -5.81186,-5.57222 v -52.90598 c 0,-3.05572 -0.23967,-7.18995 2.93589,-7.18995 l 7.07012,1.01857 c 3.17555,0 4.01437,4.91314 4.01437,7.96886 l 1.19832,29.41885 c 0,1.61775 6.77054,19.35292 11.74359,24.98504 4.13421,4.61356 -11.14441,2.27683 -12.64232,2.27683 z'],
    color: '#eab44b',
    label: {
      x: -196,
      y: 285,
      text: 'IMD',
      transform: 'rotate(-91.456582)',
    },
    name: 'IMD',
    clickable: true,
  },
  // Caudal Thalamus
  {
    coords: ['m 751.54063,230.14837 c -0.9654,-0.58945 -1.77753,-1.41364 -2.29855,-2.4176 -6.3997,-12.33285 -40.43457,2.44748 -30.93334,-14.34944 6.26235,-11.07104 18.88293,-24.23336 23.47619,-29.92937 37.63232,-46.66703 31.94546,-52.49896 45.89149,-40.49867 16.34339,14.06315 35.46779,40.26731 27.50311,56.87627 -8.68091,18.10164 -28.90132,28.56972 -42.85603,32.97981 -6.88553,2.17661 -14.3745,1.24928 -20.53851,-2.51159 z'],
    color: '#6391ba',
    label: { x: 764, y: 195, text: 'VB' },
    name: 'VB',
    clickable: true,
  },
  {
    coords: ['m 702.6931,250.08408 c -1.70668,1.0724 -3.58543,1.84356 -5.5466,2.31012 -8.15796,1.94092 -7.75551,1.35001 -17.64809,-0.60874 -7.64851,-1.51389 -29.13508,-3.80088 -28.78516,-13.26452 0.23712,-6.40644 49.04942,-10.99294 55.75085,-11.99497 10.89124,-1.62861 15.34328,-0.4974 26.58444,-0.68441 6.8894,-0.11427 6.8894,-0.11427 7.53139,2.04648 1.01022,3.40084 -9.80536,5.65793 -14.1446,9.5128 -1.19916,1.06565 -2.5487,1.95441 -3.9686,2.701 -8.45872,4.44672 -13.24572,5.87916 -19.77363,9.98224 z'],
    color: '#ce4a45',
    label: {
      x: 675,
      y: 243,
      text: 'VPMpc',
      fontSize: 11,
    },
    name: 'VPMpc',
    clickable: true,
  },
  {
    coords: ['m 700.19799,278.90249 c -11.93906,4.13489 -31.92669,13.15124 -45.78789,10.28202 -8.53727,-1.76741 -10.76401,-7.39016 -20.63105,-10.12153 -5.22224,-1.44544 12.09378,-8.19361 16.92994,-13.0134 3.58062,-3.56808 12.90014,-7.84948 17.97488,-7.2793 7.7772,0.8743 20.34284,2.0672 28.05448,3.42349 10.04683,1.76741 46.3706,-4.89015 51.97889,-4.17731 9.50606,1.20832 -46.25154,20.1004 -48.51925,20.88603 z'],
    color: '#ce4a45',
    label: { x: 663, y: 279, text: 'VM' },
    name: 'VM',
    clickable: true,
  },
  {
    coords: ['m 650.70914,257.12124 c 0,8.11892 -7.19785,14.70031 -16.07589,14.70031 -8.87851,0 -16.07588,-6.58139 -16.07588,-14.70031 0,-8.11892 7.19737,-14.70032 16.07588,-14.70032 8.87804,0 16.07589,6.5814 16.07589,14.70032 z'],
    color: '#ffffff',
    label: {
      x: 624,
      y: 261,
      text: 'SPFm',
      fontSize: 8,
    },
    name: 'SPFm',
    clickable: false,
  },
  {
    coords: ['m 764.43777,126.03813 c 20.00689,8.08517 -16.63835,41.06065 -23.26747,51.54271 -4.19272,6.62912 -8.74935,13.0105 -13.46405,19.27621 -3.20515,4.25924 -14.36246,23.54752 -19.77747,24.93416 -11.06767,2.83452 -3.31649,-14.8478 -3.7898,-20.7048 -1.10613,-13.67949 -10.80643,-28.78179 -14.56825,-42.11329 -2.70968,-9.60052 -17.4852,-28.34704 -12.14007,-38.22084 6.34043,-11.71013 31.93393,-7.28461 42.13403,-6.06232 14.20773,1.70187 31.56134,5.96833 44.87308,11.34817 z'],
    color: '#ce4a45',
    label: { x: 708, y: 155, text: 'PO' },
    name: 'PO',
    clickable: true,
  },
  {
    coords: ['m 816.40007,154.11685 c -2.48556,1.90044 -5.94857,1.81079 -8.34014,-0.20677 -10.2883,-8.67704 -21.69816,-17.42398 -28.81746,-32.77015 -3.92474,-8.46016 -11.00933,-15.0782 -5.5466,-28.46224 5.2738,-12.92182 19.76206,-11.07825 29.23967,-8.34544 11.72508,3.38059 33.72592,15.0941 43.69948,33.53408 1.59439,2.9473 -2.15011,-1.14902 -7.94877,5.78856 -3.31071,3.96138 -4.81978,9.31808 -10.60352,17.64232 -3.98932,5.74228 -8.27555,10.21455 -11.68266,12.81964 z'],
    color: '#6391ba',
    label: { x: 795, y: 119, text: 'LGd' },
    name: 'LGd',
    clickable: true,
  },
  {
    coords: ['m 663.75199,230.11448 c -13.95952,5.5731 -32.627,11.07633 -33.34612,2.28072 -0.69741,-8.52908 -2.31686,-14.96975 -2.8856,-22.97396 -0.57258,-8.05819 -0.70657,-13.9306 -1.6686,-20.96603 -1.4469,-10.58183 -1.4469,-10.58183 -0.50993,-20.01751 0.38655,-3.89437 0.47233,-15.28302 5.08341,-23.6974 3.95511,-7.21761 7.49718,-6.96457 14.01592,-11.32262 10.34228,-6.91493 15.48112,-8.63415 20.74963,-8.4028 10.91728,0.47957 24.52496,38.66764 28.10895,53.67112 3.49433,14.62561 10.22804,26.98834 3.2572,37.69066 -5.81651,8.93106 -23.26555,9.53931 -32.80486,13.73782 z'],
    color: '#ebb54b',
    label: { x: 652, y: 184, text: 'PF' },
    name: 'PF',
    clickable: true,
  },
  {
    coords: ['m 621.32946,149.41096 c -9.70173,0.28485 -12.41141,1.92357 -17.02972,-11.84027 -2.95308,-8.80042 -2.11298,-13.60382 5.32055,-19.90086 10.89077,-9.22698 16.9179,-2.34242 18.24672,6.03581 0.6497,4.09392 0.94853,4.88099 1.65608,9.4352 0.77984,5.02268 -2.89187,12.52466 -8.19363,16.27012 z'],
    color: '#ebb54b',
    label: {
      x: 608,
      y: 135,
      text: 'PVT',
      fontSize: 9,
    },
    name: 'PVT',
    clickable: true,
  },
  {
    coords: ['m 616.23833,196.7808 c -5.215,0 -11.26479,0.7167 -13.67901,-4.2414 -1.81995,-3.7363 -0.0881,-13.02642 -0.11667,-17.16854 -0.0289,-4.27129 -3.38879,-33.10898 0.21785,-35.3121 -0.4092,0.25014 7.51838,10.72062 9.07662,11.51878 5.9423,3.04418 11.09561,-1.10854 13.07846,7.40367 0.99913,4.28912 -1.13603,9.64967 -1.70235,13.94988 -0.85985,6.52501 4.23996,23.84971 -6.87493,23.84971 z'],
    color: '#ebb54b',
    label: {
      x: -199,
      y: 612,
      text: 'IMD',
      transform: 'rotate(-91.456505)',
    },
    name: 'IMD',
    clickable: true,
  },
  {
    coords: ['m 766.87166,122.74169 c -12.93435,-3.22057 -55.02691,-18.42986 -67.1554,-13.0134 -7.71116,3.44374 -23.00576,3.90064 -29.88263,-1.60642 -4.69012,-3.75655 -2.91114,-4.88148 -4.25345,-10.44302 -1.12445,-4.65928 -0.009,-13.14498 3.47988,-14.25498 6.1886,-1.96936 37.58415,-4.46938 43.9906,-5.18463 18.90944,-2.11155 42.18317,-0.47716 63.78204,-0.96396 9.63955,-0.21785 -9.75283,12.28755 -7.50344,23.37303 2.11829,10.44061 5.58757,22.09338 -2.4576,22.09338 z'],
    color: '#ce4a45',
    label: { x: 712, y: 100, text: 'LP' },
    name: 'LP',
    clickable: true,
  },
  {
    coords: ['m 736.82951,251.6397 c -3.33432,0.6661 -31.78933,3.19311 -31.9614,1.6368 4.42794,-8.3117 10.99296,-8.3228 17.96187,-9.62896 6.10811,-1.14517 10.84307,-3.94836 16.55497,-7.28412 2.24458,-1.31098 17.56761,-11.77761 16.01131,3.27792 -0.75719,7.328 -14.88155,11.5911 -18.56675,11.99836 z'],
    color: '#ffffff',
    label: {
      x: 721,
      y: 250,
      text: 'VPLpc',
      fontSize: 7,
    },
    name: 'VPLpc',
    clickable: false,
  },
  {
    coords: ['m 616.17595,253.46544 c -1.66909,4.04668 -13.17051,18.04669 -11.97522,8.64234 0.74032,-5.81988 0.66272,-16.89092 -0.0564,-28.59285 -0.52101,-8.47607 -5.77313,-31.99513 2.90296,-34.76505 5.31813,-1.6985 16.10286,-1.15675 16.38724,4.81977 0.24098,5.06076 4.46552,26.74977 5.54274,31.81053 1.47582,6.93278 -8.2047,6.85807 -12.80133,18.08526 z'],
    color: '#ebb54b',
    label: {
      x: -250,
      y: 614,
      text: 'SPA',
      transform: 'rotate(-91.456505)',
    },
    name: 'SPA',
    clickable: true,
  },
  {
    coords: ['m 826.48677,180.79885 c 3.74545,4.23948 8.75561,7.20316 14.28822,8.384 14.28004,3.04707 16.17711,-5.81361 15.926,-15.29508 -0.19376,-7.29667 -2.86198,-40.09669 -5.30176,-46.96488 -4.15272,-11.68796 -18.0809,9.20192 -23.12625,17.39555 -3.91511,6.35728 -14.36197,10.46373 -11.81713,21.00217 0.93262,3.86353 4.90701,9.6786 10.03092,15.47824 z'],
    color: '#ffffff',
    label: { x: 825, y: 164, text: 'LGv' },
    name: 'LGv',
    clickable: false,
  },
  {
    coords: ['m 851.23189,209.66242 c 0.70369,4.55422 -4.21538,9.46894 -4.60144,14.29643 -0.51572,6.45753 5.61214,21.9724 -9.56003,17.87559 -10.42519,-2.81523 9.06504,-17.77052 -3.87221,-24.37651 -6.83734,-3.49096 -12.72567,3.51313 -9.40484,-9.90753 1.56354,-6.31874 1.31966,-15.35099 6.85517,-17.5493 3.45048,-1.36978 14.50995,0.97504 17.38735,3.6346 3.78208,3.4953 2.41664,10.9809 3.196,16.02672 z'],
    color: '#ffffff',
    label: { x: 830, y: 211, text: 'RT' },
    name: 'RT',
    clickable: false,
  },
];

/*
  {
    coords: [''],
    color: '',
    label: { x: 0, y: 0, text: '' },
    name: '',
    clickable: true,
  },
*/


function renderLabels(paper) {
  paper.text(55, 26, 'Rostral thalamus');
  paper.text(10, 43, 'Medial');
  paper.text(182, 43, 'Lateral');
  paper.line(12, 53, 12, 302).attr({ stroke: '#aaa', 'stroke-width': 2, 'stroke-dasharray': 5 });

  paper.text(357, 26, 'Middle thalamus');
  paper.text(267, 43, 'Medial');
  paper.text(502, 43, 'Lateral');
  paper.line(270, 53, 270, 302).attr({ stroke: '#aaa', 'stroke-width': 2, 'stroke-dasharray': 5 });

  paper.text(665, 26, 'Caudal thalamus');
  paper.text(589, 43, 'Medial');
  paper.text(814, 43, 'Lateral');
  paper.line(593, 53, 593, 302).attr({ stroke: '#aaa', 'stroke-width': 2, 'stroke-dasharray': 5 });
}

class ThalamusAtlas extends React.Component {
  constructor(props) {
    super(props);
    this.atlasRef = React.createRef();
  }

  componentDidMount() {
    this.svgRender();
  }

  componentDidUpdate() {
    this.svgRender();
  }

  handleClickAll = () => {
    const { actions } = this.props;
    return actions.updateCellPopulationChoice(thalamusRegions);
  }

  handleClickNone = () => {
    const { actions } = this.props;
    return actions.updateCellPopulationChoice();
  }

  svgRender() {
    const paper = Snap(this.atlasRef.current);
    const { actions, cellPopulation } = this.props;
    if (paper) {
      paper.attr({ viewBox: '0 0 888 360' });

      renderLabels(paper);

      regions.forEach((region) => {
        const rendered = paper.path(region.coords[0]);
        const label = paper.text(region.label.x, region.label.y, region.label.text);
        const fontSize = region.label.fontSize || 14;
        const selected = cellPopulation.get('chosen').includes(region.name);

        // common label settings
        label.attr({
          fill: region.color,
          'text-anchor': 'start',
          'font-weight': 'normal',
          'font-size': fontSize,
        });

        if (region.label.transform) {
          label.attr({ transform: region.label.transform });
        }

        // region path settings
        if (region.clickable) {
          rendered.click(function() {
            if (selected) {
              actions.removeCellPopulationChoice([region.name]);
            } else {
              actions.addCellPopulationChoice([region.name]);
            }
          });
          label.click(function() {
            if (selected) {
              actions.removeCellPopulationChoice([region.name]);
            } else {
              actions.addCellPopulationChoice([region.name]);
            }
          });
          // if it is clickable then we need to make the cursor show that.
          rendered.attr({
            cursor: 'pointer',
          });
          label.attr({
            cursor: 'pointer',
          });

          rendered.attr({
            fill: '#ffffff',
            stroke: region.color,
            'stroke-width': 1,
          });

          if (selected) {
            rendered.attr({
              fill: region.color,
            });
            label.attr({
              fill: '#dddddd',
            });
          }
        } else {
          rendered.attr({
            fill: 'none',
            stroke: '#cccccc',
            'stroke-width': 1,
          });
          label.attr({
            fill: '#6e6e6e',
          });
        }
      });
    }
  }

  render() {
    return (
      <div>
        <div className="btn-group">
          <button onClick={this.handleClickAll} className="btn btn-outline-primary">All</button>
          <button onClick={this.handleClickNone} className="btn btn-outline-primary">None</button>
        </div>
        <svg ref={this.atlasRef} width="100%" height="360px" />
      </div>
    );
  }
}

export default ThalamusAtlas;

ThalamusAtlas.propTypes = {
  cellPopulation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ThalamusAtlas.jsx